/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {SuperAdminDemoRoleIds} from '@ion/core/src/entities/LabelRulesValidator';
import {GlobalGroupChooser} from '@ion/dls/src/components/groupchooser/GlobalGroupChooser';
import {roleSelector} from '@/store/selectors/initialization-selectors';
import {useSelectGlobalGroup} from '../hooks/useSelectGlobalGroup';
import {setCurrentMoveToAccount} from '../store/actions/admin-assets';
import {showChangeGroup} from '../store/actions/global-group-chooser';

export interface GlobalGroupChooserDrawerProps {
  onRequestOpen?: () => void;
}

/**
 * @GlobalGroupChooserDrawer
 */
export const GlobalGroupChooserDrawer = ({
  onRequestOpen
}: GlobalGroupChooserDrawerProps = {}) => {
  const dispatch            = useDispatch();
  const onSelectGlobalGroup = useSelectGlobalGroup();
  const role                = useSelector(roleSelector);
  const {
    accountHierarchy,
    globalGroup,
    groupChooser : {
      isViewing: openChooser
    }
  } = useSelector(({globalGroup}) => globalGroup);

  function onClick() {
    if (!openChooser && onRequestOpen) {
      onRequestOpen();
    } else {
      dispatch(showChangeGroup(!openChooser));
    }
  }

  function onCloseDrawer() {
    dispatch(showChangeGroup(false));
  }

  function resetDeviceMovedAccount(group) {
    dispatch(setCurrentMoveToAccount(group));
  }

  const onlyAccountId = useMemo(() => SuperAdminDemoRoleIds.includes(role.id), [role]);

  return (
    <GlobalGroupChooser accountHierarchy={accountHierarchy}
      selectedGroup={globalGroup}
      drawerOpen={openChooser}
      onDrawerClick={onClick}
      onlyAccountId={onlyAccountId}
      onCloseDrawer={onCloseDrawer}
      resetDeviceMovedAccount={resetDeviceMovedAccount}
      hasAssetDeviceMove={true}
      onSelectGroup={onSelectGlobalGroup} />
  );
};

export default GlobalGroupChooserDrawer;
